module.exports = __webpack_public_path__ + "img/cute pupies-01.db85b57e.png";